import React, { useRef, useEffect, useState } from "react"
import { Button, Card, Popconfirm, Tree } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { YhForm } from "../../../../components2/YhFormBox";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "../../../../components2/YhFormBox/Types";
import useMdmModel from "../../../../model/mdmModel"
import { useOrganizationModel } from "../organizationModel"
import { IOrganDetail, OptType } from "../organizationTypes"
import { useNavModel } from "../../../../model/navModel";

const OrganForm = () => {
    const formRef = useRef<IYhFormRef>()
    const { organTree,root, organTreeRowKey, addTreeFrom, optType, organTreeRow,loadData,setOrganTreeRow,setOrganTreePRow, setRoot,setOrganTreeRowKey,changeTreeForm,insertTreeForm,updataTreeForm,addPeerTreeForm,setAddTreeFrom } = useOrganizationModel()
    const { mdmCatalog, mdmBranch } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState } = useNavModel()
    const [peerAndSon, setPeerAndSon] = useState(-1)
    useEffect(() => {
        formRef.current?.resetFields();
        setPeerAndSon(optType)
    }, [optType])
    const item = [
        {
            type: FormItemTypeEnum.Select,
            fieldLabel: "分支编码",
            fieldName: "branch",
            span: 12,
            // disable:root,
            options: mdmBranch
        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "数据版本号",
            fieldName: "ver",
            span: 12,
            disable: true,
        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "父级编码",
            fieldName: "pcode",
            disable:true,
            span: 12,
        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "机构编码",
            fieldName: "code",
            span: 12,
            rules: [{ required: true, message: '该项为必填项' }]
        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "机构名称",
            fieldName: "name",
            span: 12,
            rules: [{ required: true, message: '该项为必填项' }]

        }, {
            type: FormItemTypeEnum.Input,
            fieldLabel: "备注",
            fieldName: "note",
            span: 12,
        }, {
            type: FormItemTypeEnum.Switch,
            fieldLabel: "状态",
            fieldName: "enable",
            valuePropName: "checked",
            span: 12,
        }
    ]
    const onFinish = ()=>{
        if(optType===OptType.ADD_ROOT||optType===OptType.ADD_SAME_LEVEL||optType===OptType.ADD_CHILD_LEVEL){
            return addPeerTreeForm()
        }
        if(optType===OptType.DETAIL){
           return updataTreeForm()
        }
    }
    const onChange = (value:any)=>{
        if(optType==OptType.DETAIL){
            changeTreeForm(value)
        }else{
            insertTreeForm(value)
        }
    }
    const formConfig: IYhForm = {
        formRef: formRef,
        labelCol: { span: 6 },
        disabled: false,
        formValues: peerAndSon === 4 ? {...organTreeRow} : {...addTreeFrom},
        items: item,
        onFinish:onFinish,
        onChange:onChange
    }
    const onOk = () => {
        formRef.current?.inst().submit()
    }
    const reset = () => {
        formRef.current?.resetFields()
        setOrganTreeRowKey([])
        setOrganTreeRow({})
        setOrganTreePRow({})
        setAddTreeFrom({})
        setRoot(false)

    }
    return <YhBox title="字典表单" width="100vw">
        <YhForm {...formConfig} />
        <div style={{ marginLeft: "150px" }}>
            <Button onClick={onOk} shape="round" type="link">{optType != 4 ? "添加" : "修改"}</Button>
            <Button onClick={reset} shape="round" type="link">重置</Button>
            <Button onClick={()=>{closeNav("2-5")}} shape="round">取消</Button>
        </div>
    </YhBox>
}
export default OrganForm